module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_4.a88d5fae.jpg";